import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	nonPlaceholdersSegmentTooltipText: {
		id: 'version-progress.related-work-progress-bar.non-placeholders-segment-tooltip-text',
		defaultMessage: '{numNonPlaceholders} added',
		description: 'Tooltip for the non-placeholders segment of the progress bar in version page.',
	},
	placeholdersSegmentTooltipText: {
		id: 'version-progress.related-work-progress-bar.placeholders-segment-tooltip-text',
		defaultMessage:
			'{numPlaceholders} {numPlaceholders, plural, one {placeholder} other {placeholders}}',
		description: 'Tooltip for the placeholders segment of the progress bar in version page.',
	},
});
